/**
 * Loads the spreadsheet library on demand.
 *
 * `xlsx` is around 410 KB in the production bundle and is only needed when an
 * admin imports a member list or downloads a template or report. Importing it
 * statically meant every user paid for it on first load. This keeps it in its
 * own chunk, fetched at the moment it is actually used.
 */
export const loadXlsx = () => import('xlsx');

export default loadXlsx;
